/**
 * Espelho (frontend) das regras de prazo do backend
 * (bravohub-api/utils/regrasPrazo.js) — usado só para dar feedback
 * imediato na UI (atributo `min` do input, texto de dica). A validação
 * que realmente vale é a do servidor.
 *
 * Regra: antecedência MÍNIMA em dias úteis por prioridade. Uma data com
 * MAIS antecedência é sempre permitida, nunca menos.
 */

export const MIN_DIAS_UTEIS_POR_PRIORIDADE: Record<string, number> = {
  urgente: 1, // emergências reais — 1 a 2 dias úteis, 1 é o piso
  alta: 3,
  media: 5,
  baixa: 8,
};

/**
 * Feriados nacionais (+ Carnaval e Corpus Christi, tratados como dia não
 * útil na prática da maioria das empresas) — mesma lista do backend
 * (bravohub-api/utils/regrasPrazo.js e a tabela
 * pipebravo.feriados_nacionais usada pelo temporizador).
 */
const FERIADOS_NACIONAIS = new Set([
  '2025-01-01', '2025-03-03', '2025-03-04', '2025-04-18', '2025-04-21',
  '2025-05-01', '2025-06-19', '2025-09-07', '2025-10-12', '2025-11-02',
  '2025-11-15', '2025-11-20', '2025-12-25',
  '2026-01-01', '2026-02-16', '2026-02-17', '2026-04-03', '2026-04-21',
  '2026-05-01', '2026-06-04', '2026-09-07', '2026-10-12', '2026-11-02',
  '2026-11-15', '2026-11-20', '2026-12-25',
  '2027-01-01', '2027-02-08', '2027-02-09', '2027-03-26', '2027-04-21',
  '2027-05-01', '2027-05-27', '2027-09-07', '2027-10-12', '2027-11-02',
  '2027-11-15', '2027-11-20', '2027-12-25',
  '2028-01-01', '2028-02-28', '2028-02-29', '2028-04-14', '2028-04-21',
  '2028-05-01', '2028-06-15', '2028-09-07', '2028-10-12', '2028-11-02',
  '2028-11-15', '2028-11-20', '2028-12-25',
]);

function ehFeriado(data: Date): boolean {
  const ano = data.getFullYear();
  const mes = String(data.getMonth() + 1).padStart(2, '0');
  const dia = String(data.getDate()).padStart(2, '0');
  return FERIADOS_NACIONAIS.has(`${ano}-${mes}-${dia}`);
}

export function adicionarDiasUteis(dataBase: Date, dias: number): Date {
  const resultado = new Date(dataBase);
  let adicionados = 0;
  while (adicionados < dias) {
    resultado.setDate(resultado.getDate() + 1);
    const diaSemana = resultado.getDay();
    if (diaSemana !== 0 && diaSemana !== 6 && !ehFeriado(resultado)) {
      adicionados++;
    }
  }
  return resultado;
}

export function calcularDataMinimaVencimento(prioridade: string, dataBase: Date = new Date()): Date {
  const dias = MIN_DIAS_UTEIS_POR_PRIORIDADE[prioridade] ?? MIN_DIAS_UTEIS_POR_PRIORIDADE.media;
  const minima = adicionarDiasUteis(dataBase, dias);
  minima.setHours(12, 0, 0, 0);
  return minima;
}

/** Formata Date como YYYY-MM-DD, para usar no atributo `min` de <input type="date"> */
export function paraInputDate(data: Date): string {
  const ano = data.getFullYear();
  const mes = String(data.getMonth() + 1).padStart(2, '0');
  const dia = String(data.getDate()).padStart(2, '0');
  return `${ano}-${mes}-${dia}`;
}
